export default __webpack_public_path__ + "static/media/Linkedin.5ff9243a.svg";